import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "dashboard-area company-dashboard pt-120 mb-120" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "row g-lg-4" }
const _hoisted_4 = { class: "col-lg-12" }
const _hoisted_5 = { class: "dashboard-inner" }
const _hoisted_6 = { class: "author-and-action-btn-area two mb-40" }
const _hoisted_7 = { class: "author-area two" }
const _hoisted_8 = { class: "author-img" }
const _hoisted_9 = ["src"]
const _hoisted_10 = {
  key: 1,
  src: "/assets/images/work-pages-logo.png",
  alt: ""
}
const _hoisted_11 = { class: "author-content" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", null, "Hello,", -1)
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { class: "counter-area" }
const _hoisted_15 = { class: "row g-4 justify-content-center mb-30" }
const _hoisted_16 = { class: "col-lg-4 col-sm-6" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "counter-icon" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "/assets/images/icon/save-job.svg",
    alt: "image"
  })
], -1)
const _hoisted_18 = { class: "coundown" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("p", null, "Live Jobs", -1)
const _hoisted_20 = { class: "d-flex align-items-center" }
const _hoisted_21 = { class: "odometer" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("span", null, "+", -1)
const _hoisted_23 = { class: "col-lg-4 col-sm-6" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", { class: "counter-icon" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "/assets/images/icon/pending-icon.svg",
    alt: "image"
  })
], -1)
const _hoisted_25 = { class: "coundown" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("p", null, "Pending Job", -1)
const _hoisted_27 = { class: "d-flex align-items-center" }
const _hoisted_28 = { class: "odometer" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("span", null, "+", -1)
const _hoisted_30 = { class: "col-lg-4 col-sm-6" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("div", { class: "counter-icon" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "/assets/images/icon/closed-icon.svg",
    alt: "image"
  })
], -1)
const _hoisted_32 = { class: "coundown" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("p", null, "Closed Jobs", -1)
const _hoisted_34 = { class: "d-flex align-items-center" }
const _hoisted_35 = { class: "odometer" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("span", null, "+", -1)
const _hoisted_37 = { class: "row g-4 justify-content-cente" }
const _hoisted_38 = { class: "col-lg-4 col-sm-6" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("div", { class: "counter-icon" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "/assets/images/icon/total-view-icon.svg",
    alt: "image"
  })
], -1)
const _hoisted_40 = { class: "coundown" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("p", null, "Total Reviews / Total Applied", -1)
const _hoisted_42 = { class: "d-flex align-items-center" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("h3", { class: "odometer" }, null, -1)
const _hoisted_44 = { class: "col-lg-4 col-sm-6" }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("div", { class: "counter-icon" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "/assets/images/icon/highlight-icon.svg",
    alt: "image"
  })
], -1)
const _hoisted_46 = { class: "coundown" }
const _hoisted_47 = /*#__PURE__*/_createElementVNode("p", null, "Highlighted Jobs", -1)
const _hoisted_48 = { class: "d-flex align-items-center" }
const _hoisted_49 = { class: "odometer" }
const _hoisted_50 = /*#__PURE__*/_createElementVNode("span", null, "+", -1)
const _hoisted_51 = { class: "col-lg-4 col-sm-6" }
const _hoisted_52 = /*#__PURE__*/_createElementVNode("div", { class: "counter-icon" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "/assets/images/icon/featured-icon.svg",
    alt: "image"
  })
], -1)
const _hoisted_53 = { class: "coundown" }
const _hoisted_54 = /*#__PURE__*/_createElementVNode("p", null, "Our Followers", -1)
const _hoisted_55 = { class: "d-flex align-items-center" }
const _hoisted_56 = { class: "odometer" }
const _hoisted_57 = /*#__PURE__*/_createElementVNode("span", null, "+", -1)
const _hoisted_58 = { class: "new-applied-job-area" }
const _hoisted_59 = /*#__PURE__*/_createElementVNode("h5", null, "New Applied List:", -1)
const _hoisted_60 = { class: "table-wrapper2" }
const _hoisted_61 = { class: "eg-table table category-table mb-0" }
const _hoisted_62 = { key: 0 }
const _hoisted_63 = { "data-label": "Candidate Image" }
const _hoisted_64 = { class: "employee-info" }
const _hoisted_65 = { class: "employee-img" }
const _hoisted_66 = ["src"]
const _hoisted_67 = {
  key: 1,
  src: "/assets/images/icon/user-2.svg",
  alt: ""
}
const _hoisted_68 = { "data-label": "Candidate Detail" }
const _hoisted_69 = { class: "employee-info" }
const _hoisted_70 = { class: "employee-content" }
const _hoisted_71 = ["onClick"]
const _hoisted_72 = /*#__PURE__*/_createElementVNode("span", null, "Applied On:", -1)
const _hoisted_73 = /*#__PURE__*/_createElementVNode("span", null, "Status:", -1)
const _hoisted_74 = { "data-label": "Career Summary" }
const _hoisted_75 = { class: "carrer-summary" }
const _hoisted_76 = /*#__PURE__*/_createElementVNode("span", null, "Experience:", -1)
const _hoisted_77 = /*#__PURE__*/_createElementVNode("span", null, "Salary:", -1)
const _hoisted_78 = { "data-label": "Actions" }
const _hoisted_79 = { class: "action-btn-group" }
const _hoisted_80 = { key: 0 }
const _hoisted_81 = ["onClick"]
const _hoisted_82 = {
  key: 1,
  class: "review"
}
const _hoisted_83 = { key: 1 }
const _hoisted_84 = ["onClick"]
const _hoisted_85 = { key: 1 }
const _hoisted_86 = { key: 2 }
const _hoisted_87 = ["onClick"]
const _hoisted_88 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_company_menu = _resolveComponent("company-menu")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_company_menu),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    (_ctx.company_logo)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          width: "200",
                          src: _ctx.company_logo
                        }, null, 8, _hoisted_9))
                      : (_openBlock(), _createElementBlock("img", _hoisted_10))
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    _hoisted_12,
                    (this.user)
                      ? (_openBlock(), _createElementBlock("h4", _hoisted_13, _toDisplayString(_ctx.user.name), 1))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("div", null, [
                  _createVNode(_component_router_link, {
                    to: "/company/profile",
                    class: "primry-btn-2 lg-btn w-unset"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Edit Profile")
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, [
                    _createVNode(_component_router_link, {
                      class: "counter-single two",
                      to: "/company/job-list"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_17,
                        _createElementVNode("div", _hoisted_18, [
                          _hoisted_19,
                          _createElementVNode("div", _hoisted_20, [
                            _createElementVNode("h3", _hoisted_21, _toDisplayString(_ctx.company?.data.live_jobs), 1),
                            _hoisted_22
                          ])
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_23, [
                    _createVNode(_component_router_link, {
                      class: "counter-single three",
                      to: "/company/job-list"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_24,
                        _createElementVNode("div", _hoisted_25, [
                          _hoisted_26,
                          _createElementVNode("div", _hoisted_27, [
                            _createElementVNode("h3", _hoisted_28, _toDisplayString(_ctx.company?.data.pending_jobs), 1),
                            _hoisted_29
                          ])
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_30, [
                    _createVNode(_component_router_link, {
                      class: "counter-single four",
                      to: "/company/job-list"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_31,
                        _createElementVNode("div", _hoisted_32, [
                          _hoisted_33,
                          _createElementVNode("div", _hoisted_34, [
                            _createElementVNode("h3", _hoisted_35, _toDisplayString(_ctx.company?.data.closed_jobs), 1),
                            _hoisted_36
                          ])
                        ])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_37, [
                  _createElementVNode("div", _hoisted_38, [
                    _createVNode(_component_router_link, {
                      class: "counter-single",
                      to: "/company/applications"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_39,
                        _createElementVNode("div", _hoisted_40, [
                          _hoisted_41,
                          _createElementVNode("div", _hoisted_42, [
                            _hoisted_43,
                            _createElementVNode("span", null, _toDisplayString(_ctx.companyCounts.reviews_count), 1),
                            _createTextVNode("/"),
                            _createElementVNode("span", null, _toDisplayString(_ctx.companyCounts.total_applied_job), 1)
                          ])
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_44, [
                    _createVNode(_component_router_link, {
                      class: "counter-single three",
                      to: "/company/applications"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_45,
                        _createElementVNode("div", _hoisted_46, [
                          _hoisted_47,
                          _createElementVNode("div", _hoisted_48, [
                            _createElementVNode("h3", _hoisted_49, _toDisplayString(_ctx.companyCounts.highlighted_jobs), 1),
                            _hoisted_50
                          ])
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_51, [
                    _createVNode(_component_router_link, {
                      class: "counter-single four",
                      to: "/company/job-list"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_52,
                        _createElementVNode("div", _hoisted_53, [
                          _hoisted_54,
                          _createElementVNode("div", _hoisted_55, [
                            _createElementVNode("h3", _hoisted_56, _toDisplayString(_ctx.companyCounts.followers_count), 1),
                            _hoisted_57
                          ])
                        ])
                      ]),
                      _: 1
                    })
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_58, [
                _hoisted_59,
                _createElementVNode("div", _hoisted_60, [
                  _createElementVNode("table", _hoisted_61, [
                    (_ctx.newApplications.length > 0)
                      ? (_openBlock(), _createElementBlock("tbody", _hoisted_62, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.newApplications, (application) => {
                            return (_openBlock(), _createElementBlock("tr", {
                              key: application.id
                            }, [
                              _createElementVNode("td", _hoisted_63, [
                                _createElementVNode("div", _hoisted_64, [
                                  _createElementVNode("div", _hoisted_65, [
                                    _createVNode(_component_router_link, {
                                      to: '/job-seeker/'+application.user?.id
                                    }, {
                                      default: _withCtx(() => [
                                        (application.user?.photo)
                                          ? (_openBlock(), _createElementBlock("img", {
                                              key: 0,
                                              src: application.user?.photo,
                                              alt: ""
                                            }, null, 8, _hoisted_66))
                                          : (_openBlock(), _createElementBlock("img", _hoisted_67))
                                      ]),
                                      _: 2
                                    }, 1032, ["to"])
                                  ])
                                ])
                              ]),
                              _createElementVNode("td", _hoisted_68, [
                                _createElementVNode("div", _hoisted_69, [
                                  _createElementVNode("div", _hoisted_70, [
                                    _createTextVNode(_toDisplayString(application.user_name) + " ", 1),
                                    _createElementVNode("button", {
                                      type: "button",
                                      class: "btn btn-primary",
                                      "data-bs-toggle": "modal",
                                      "data-bs-target": "#exampleModal",
                                      onClick: ($event: any) => (_ctx.seekerDetail(application.user_id))
                                    }, _toDisplayString(application.job.job_title), 9, _hoisted_71),
                                    _createElementVNode("p", null, [
                                      _createElementVNode("span", null, "Total reviews: (" + _toDisplayString(application.user?.reviews?.length ?? 0) + ")", 1)
                                    ]),
                                    _createElementVNode("p", null, [
                                      _hoisted_72,
                                      _createTextVNode(" " + _toDisplayString(application.applied_on ?? ''), 1)
                                    ]),
                                    _createElementVNode("p", null, [
                                      _hoisted_73,
                                      _createTextVNode(" " + _toDisplayString(application.status_name ?? 'No Status'), 1)
                                    ])
                                  ])
                                ])
                              ]),
                              _createElementVNode("td", _hoisted_74, [
                                _createElementVNode("div", _hoisted_75, [
                                  _createElementVNode("h6", null, [
                                    _createTextVNode(_toDisplayString(application.user?.designtion?.name ?? 'No Current Designation') + " ", 1),
                                    _createElementVNode("span", null, "(" + _toDisplayString(application.user?.job_location?.name ?? 'No Location') + ")", 1)
                                  ]),
                                  _createElementVNode("ul", null, [
                                    _createElementVNode("li", null, [
                                      _hoisted_76,
                                      _createTextVNode(" " + _toDisplayString(application.experience) + " Years ", 1)
                                    ]),
                                    _createElementVNode("li", null, [
                                      _hoisted_77,
                                      _createTextVNode(" " + _toDisplayString(application.job.currency) + " " + _toDisplayString(application.salary) + " / " + _toDisplayString(application.job.payment_mode), 1)
                                    ])
                                  ])
                                ])
                              ]),
                              _createElementVNode("td", _hoisted_78, [
                                _createElementVNode("div", _hoisted_79, [
                                  _createElementVNode("ul", null, [
                                    (this.user.sub_accesses.length > 0)
                                      ? (_openBlock(), _createElementBlock("li", _hoisted_80, [
                                          (!_ctx.cvClicked && (_ctx.filteredSubAccesses[0].cv_credit > 0))
                                            ? (_openBlock(), _createElementBlock("button", {
                                                key: 0,
                                                class: "review",
                                                onClick: ($event: any) => (_ctx.downloadCv(application.cv))
                                              }, " Download CV ", 8, _hoisted_81))
                                            : _createCommentVNode("", true),
                                          (_ctx.cvClicked && (_ctx.filteredSubAccesses[0].cv_credit > 0))
                                            ? (_openBlock(), _createElementBlock("button", _hoisted_82, " Downloading... "))
                                            : _createCommentVNode("", true)
                                        ]))
                                      : _createCommentVNode("", true),
                                    (application.status_name != 'Shortlisted')
                                      ? (_openBlock(), _createElementBlock("li", _hoisted_83, [
                                          (!application.isLoading)
                                            ? (_openBlock(), _createElementBlock("button", {
                                                key: 0,
                                                onClick: ($event: any) => (_ctx.updateCandidateApplication('shortlist', application))
                                              }, " Shortlist", 8, _hoisted_84))
                                            : (_openBlock(), _createElementBlock("button", _hoisted_85, "processing..."))
                                        ]))
                                      : _createCommentVNode("", true),
                                    (application.status_name != 'Rejected')
                                      ? (_openBlock(), _createElementBlock("li", _hoisted_86, [
                                          (!application.isLoading)
                                            ? (_openBlock(), _createElementBlock("button", {
                                                key: 0,
                                                onClick: ($event: any) => (_ctx.updateCandidateApplication('reject', application)),
                                                class: "reject"
                                              }, " Reject", 8, _hoisted_87))
                                            : (_openBlock(), _createElementBlock("button", _hoisted_88, "processing..."))
                                        ]))
                                      : _createCommentVNode("", true)
                                  ])
                                ])
                              ])
                            ]))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}